/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { set, setCustomer, setIsLoadingLoaded, clear, clearSelectedFilters, selectFilterItem, unselectFilterItem } from './actions';
import { fetchReportsAggsFilters } from '../../../api/reportsaggsfilters';
import { selectCustomer, selectFilterItems, selectSelectedFiltersMap } from '../selectors';
import UTIL from '../util.selectedFilters';
import RADF_UTIL from '../util.urlWriter';

const thunkLoad = () => (dispatch, getState) => {
  const customerName = selectCustomer(getState());

  dispatch(clear());
  dispatch(setCustomer(customerName));
	dispatch(
		setIsLoadingLoaded({
			isLoading: true,
			isLoaded: false
		})
	);
  fetchReportsAggsFilters(customerName).then((filters) => {
		dispatch(set(filters));
		dispatch(
			setIsLoadingLoaded({
				isLoading: false,
				isLoaded: true
			})
    );
    // eslint-disable-next-line no-use-before-define
    dispatch(thunkLoadStateFromUrl());
	});
};

const thunkSetCustomerName = (customerName) => (dispatch) => { 
  dispatch(setCustomer(customerName));
  dispatch(clearSelectedFilters());
  dispatch(thunkLoad());
}

const thunkClearSelectedFilters = () => (dispatch) => { 
  dispatch(clearSelectedFilters());
  RADF_UTIL.clearUrl();
}

const thunkUnselectFilterItem = (filterKey, item, { preventUrlWrite = false } = {}) => (dispatch, getState) => { 
  const selectedFiltersMap = selectSelectedFiltersMap(getState());
  const currIsSelected = UTIL.computeIsFilterItemSelected(filterKey, item, selectedFiltersMap)
  if (currIsSelected) {
    dispatch(unselectFilterItem(filterKey, item));
    if (!preventUrlWrite) {
      RADF_UTIL.removeFromUrl(filterKey, item);
    }
  }
}

const thunkSelectFilterItem = (filterKey, item, { preventUrlWrite = false } = {}) => (dispatch, getState) => { 
  const selectedFiltersMap = selectSelectedFiltersMap(getState());
  const currIsSelected = UTIL.computeIsFilterItemSelected(filterKey, item, selectedFiltersMap)
  if (!currIsSelected) {
    dispatch(selectFilterItem(filterKey, item));
    if (!preventUrlWrite) {
      RADF_UTIL.addToUrl(filterKey, item);
    }
  }
}

const thunkToggleFilterItem = (filterKey, item) => (dispatch, getState) => { 
  const selectedFiltersMap = selectSelectedFiltersMap(getState());
  const currIsSelected = UTIL.computeIsFilterItemSelected(filterKey, item, selectedFiltersMap)
  if (currIsSelected) {
    dispatch(thunkUnselectFilterItem(filterKey, item));
  } else { 
    dispatch(thunkSelectFilterItem(filterKey, item));
  }
}

const thunkLoadStateFromUrl = () => (dispatch, getState) => { 
  if (!RADF_UTIL.CACHE.isLoaded) {
    RADF_UTIL.loadCacheFromUrl();
    const { FILTERS: URL_FILTERS } = RADF_UTIL.CACHE;
    const filterKeys = Object.keys(URL_FILTERS);

    filterKeys.forEach((filterKey) => {
      // identify selected ids
      const ids = URL_FILTERS[filterKey];
      const idsMap = ids.reduce((acc, id) => {
        acc[id] = true;
        return acc;
      }, {});

      // Map IDs to Existing Objects
      const possibleFilters = selectFilterItems(getState(), filterKey);
      const selectedFilters = possibleFilters.map(item => ((idsMap[item.id] && item) || undefined)).filter(v => v);
      selectedFilters.forEach(item => {
        dispatch(thunkSelectFilterItem(filterKey, item, { preventUrlWrite: true }));
      });
    });
  }
}

export {
  thunkClearSelectedFilters,
  thunkUnselectFilterItem,
  thunkSelectFilterItem,
  thunkLoad,
  thunkSetCustomerName,
  thunkToggleFilterItem
};
